
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","height":"16","width":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#000000","fill":"none","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12.118 15.5h-7a1 1 0 01-1-1v-9h9v9a1 1 0 01-1 1zM7.118 12.5v-4M10.118 12.5v-4M1.618 4.141L14.334 1.44M9.027.522l-2.933.623a1 1 0 00-.772 1.185v.003l.211.977 4.891-1.04-.21-.978a1 1 0 00-1.187-.77z","stroke-width":"1.000005"}})])])
          )
        }
      }
    